'use strict';
(() => {
  function initializeCart() {
    document.querySelectorAll('[data-jmo-refined-cart]').forEach(form => {
      if (form.dataset.cartRefinementReady) return;
      form.dataset.cartRefinementReady = 'true';
      const fields = [...form.querySelectorAll('input[name="updates[]"], textarea[name="note"]')];
      const originalValues = new Map(fields.map(field => [field, field.value]));
      const pending = form.querySelector('[data-cart-pending]');
      const sync = () => {
        if (pending) pending.hidden = !fields.some(field => field.value !== originalValues.get(field));
        form.querySelectorAll('[data-cart-quantity]').forEach(group => {
          const input = group.querySelector('input');
          const value = input.valueAsNumber;
          const maximum = input.max === '' ? Infinity : Number(input.max);
          group.querySelector('[data-cart-step="-1"]').disabled = Number.isFinite(value) && value <= Number(input.min);
          group.querySelector('[data-cart-step="1"]').disabled = Number.isFinite(value) && value >= maximum;
        });
      };
      form.querySelectorAll('[data-cart-step]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          const input = button.closest('[data-cart-quantity]').querySelector('input');
          if (!Number.isFinite(input.valueAsNumber)) input.value = originalValues.get(input) || '0';
          input.stepUp(Number(button.dataset.cartStep));
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      form.addEventListener('input', sync);
      form.addEventListener('change', sync);
      sync();
    });
  }
  initializeCart();
  document.addEventListener('shopify:section:load', initializeCart);
})();
